import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=d0c5dee8&scoped=true"
var script = {}
import style0 from "./UserIcon.vue?vue&type=style&index=0&id=d0c5dee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c5dee8",
  null
  
)

export default component.exports